// Favicon ya no cambia según el tema - se usa un único favicon
// function updateFavicon removida para evitar problemas de visualización en navegadores

export function useTheme() {
  const toggleTheme = () => {
    const html = document.documentElement;
    const currentTheme = html.getAttribute('data-theme') || 'dark';
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

    // Set data-theme attribute for Brutalist design system
    html.setAttribute('data-theme', newTheme);

    // Legacy support: toggle .light class
    if (newTheme === 'light') {
      html.classList.add('light');
    } else {
      html.classList.remove('light');
    }

    localStorage.setItem('theme', newTheme);
  };

  // El tema ya está puesto por el script del `<head>` de index.html, que corre
  // antes de pintar. Esto se queda porque Vue debe partir del mismo estado y
  // porque el almacenamiento puede haber cambiado en otra pestaña; pero el
  // primer pintado ya NO depende de esto.
  const initTheme = () => {
    const saved = localStorage.getItem('theme');
    const html = document.documentElement;
    // Oscuro por defecto: es el tema de la plataforma. Solo `light` explícito
    // lo cambia.
    const theme = saved === 'light' ? 'light' : 'dark';

    // Set data-theme attribute for Brutalist design system
    html.setAttribute('data-theme', theme);

    // Legacy support: add .light class
    if (theme === 'light') {
      html.classList.add('light');
    } else {
      html.classList.remove('light');
    }
  };

  return { toggleTheme, initTheme };
}
